module.exports = __webpack_public_path__ + "static/ordinace_014-7a94912e5532a40e58d66f7a69b08ba7.jpg";